import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="comb-sec footer-sec">
      <footer className="footer px-4">
        <div>
          <span>
            <span>
              <span>Copyright &copy; 2025</span>{" "}
              <span>
                <a href="https://www.dewpointheatingandac.com/" target="_blank">
                  Dewpoint Heating & Air Conditioning
                </a>
                .
              </span>
            </span>{" "}
            <span>All Right Reserved</span>
          </span>
        </div>
        <div className="ms-auto">
          <span>
            <span>Powered by&nbsp;</span>
            <span>
              <a
                href="http://www.smartedesigners.com/"
                target="_blank"
                title="Web Design and Development Company in Sri Lanka."
              >
                Smart eDesigners
              </a>
            </span>
          </span>
        </div>
      </footer>
    </div>
  );
}
export default Footer;
